import { gql } from "@apollo/client";

export const FORGOT_PASSWORD = gql`
  mutation ForgotPassword($email: Email!) {
    forgotPassword(email: $email)
  }
`;
